import React from 'react'
import Header from '../../../common/header/Header'

function Zomba() {
  return (
    <>
    <Header/>
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
    <div className="absolute inset-0 -z-10 overflow-hidden">
      <svg
        className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
        aria-hidden="true"
      >
        <defs>
          <pattern
            id="e813992c-7d03-4cc4-a2bd-151760b470a0"
            width={200}
            height={200}
            x="50%"
            y={-1}
            patternUnits="userSpaceOnUse"
          >
            <path d="M100 200V.5M.5 .5H200" fill="none" />
          </pattern>
        </defs>
        <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
          <path
            d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
            strokeWidth={0}
          />
        </svg>
        <rect width="100%" height="100%" strokeWidth={0} fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)" />
      </svg>
    </div>
    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
      <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
        <div className="lg:pr-4">
          <div className="lg:max-w-lg">
            <p className="text-base font-semibold leading-7 text-green-600">Farm Radio Trust</p>
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Digital Agriculture Advisory Transforms Lives in Ngwerero EPA, Zomba District</h1>
            <p className="mt-6 text-xl leading-8 text-gray-700">
            In a remarkable turnaround, smallholder farmers in Ngwerero EPA, Zomba District, are reaping the benefits of digital agriculture. The Tayamba and Umodzi Farmer Field Business Schools (FFBS), comprising 34 women and 15 men, have overcome market isolation and limited knowledge, thanks to the Scaling Up Farmer Field Business School (FFBS) Project.
            </p>
          </div>
        </div>
      </div>
      <div className="-ml-16 -mt-8 -mr-28 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
        <img
          className="w-[111%]  rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
          src="/image/blog/zomba.jpeg"
          alt="Zomba Farm Advisory"
        />
      </div>

      <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
        <div className="lg:pr-4">
          <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
            <p>
            Implemented by Farm Radio Trust (FRT) with support from CARE Malawi, the project introduced farmers to digital tools like the Mlimi App, radio programs, and the toll-free Mlimi Hotline. These platforms provided real-time market trends and post-harvest handling advice, empowering farmers to make informed decisions.
            </p>
            <p className="mt-6 font-semibold">
            The results have been astounding. In the 2024/25 season, Tayamba and Umodzi FFBS aggregated their pigeon peas and sold them at a premium price of K1,650.00 per kg, K150 more than local vendors offered. Two transactions generated K10,179,650.00 and K8,761,250.00, respectively, without incurring transport costs.
            </p>
            <p className="mt-6 italic">
            "The Mlimi App has changed our lives," says Obedience Mtedza. "We no longer travel long distances to find markets. We can do it from our homes."
            </p>
            <p className="mt-6 italic">
            Esnart Dyton adds, "We are now making profits that help us take care of our homes and families."
            </p>
            <p className="mt-6">
            The success of Tayamba and Umodzi FFBS is a testament to the power of digital agriculture in transforming smallholder farming into a viable business. The groups plan to expand into soybean and groundnut processing, cementing their position as digital entrepreneurs leading their community toward a brighter future.
            </p>
            <p className="mt-6">
            This partnership between CARE Malawi and Farm Radio Trust has connected smallholder farmers to markets and opportunities, making them more independent, informed, and successful.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
  )
}

export default Zomba
